module.exports = __webpack_public_path__ + "static/media/IMG_5882.b1fe294f.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_5882.PNG
// module id = 1128
// module chunks = 0 1